const EXTERNAL_SOURCES_CT_GOV_PROMPTS = [
  "Give me the list of trial locations of the clinical trials where Dr. [HCP Name] is involved?",
  "What are the recruitment metrics of study [topic name]?",
];

const EXTERNAL_SOURCES_PUBMED_PROMPTS = [
  "What is the comparative efficacy of currently available PAH drugs?",
  "Provide the details of research that Dr. [HCP Name] is involved in?",
];
const EXTERNAL_SOURCES_PROMPT_CATEGORIES = Object.freeze({
  "ct.gov": EXTERNAL_SOURCES_CT_GOV_PROMPTS,
  pubmed: EXTERNAL_SOURCES_PUBMED_PROMPTS,
});

export const EXTERNAL_SOURCES_CATEGORY_NAMES = Object.freeze(
  Object.keys(EXTERNAL_SOURCES_PROMPT_CATEGORIES)
);

export const PromptDialogData = {
  doctor: [
    {
      heading: "Call Planning",
      description: "Help me plan call with dr vandana arora",
    },
    {
      heading: "Meeting Frequency",
      description: "How many times have I met Dr. Amit Gupta in last 3 months?",
    },
    {
      heading: "Thank-You Email",
      description: "Generate thank-you email for Dr. vandana arora",
    },
    {
      heading: "Generate Speaking Notes",
      description:
        "Can you generate some speaking notes for my call with Dr. Amit Gupta?",
    },
    {
      heading: "Call Coverage with doctor",
      description: "how is my call coverage with Aman Gupta for last 3 months?",
    },
  ],
  brand: [
    {
      heading: "Key Detailing Messages",
      description: "What are the key detailing messages for Atorvastatin?",
    },
    {
      heading: "Recommended Dosage",
      description: "What is the recommended dosage for Atorvastatin?",
    },
    {
      heading: "Adverse Effects of Drugs",
      description:
        "What are the potential adverse effects associated with Jardiance?",
    },
  ],
  ut: [
    {
      heading: "Pending referrals",
      description:
        "Which HCPs have pending referrals for longer than 10 days? ",
    },
    {
      heading: "Targets Idle 60 Days",
      description: "Which targets have not been contacted in the past 60 days?",
    },
    {
      heading: "Call notes",
      description: "Summarize this call for me [Given call notes]",
    },
    {
      heading: "Thank you note",
      description: "Draft a thank you note to an HCP",
    },
    {
      heading: "Starts - Quarter",
      description: "How many starts do I have this quarter?",
    },
    {
      heading: "Discontinuations",
      description: "How many discontinuations did I have last month?",
    },
    {
      heading: "Most starts",
      description: "What HCP has the most starts this quarter?",
    },
    {
      heading: "Starts - trend",
      description: "Have my no starts been increasing month over month?",
    },
    {
      heading: "Discontinuations - reasons",
      description:
        "What is the most common reason for discontinuation in my territory this quarter?",
    },
    {
      heading: "Starts - Month",
      description: "How many no starts did I have last month?",
    },
    {
      heading: "Starts - Tyvaso",
      description:
        "How many starts did Dr [HCP Name] have for Tyvaso in the lastquarter?",
    },
    {
      heading: "Referral for product",
      description:
        "Who has not written a referral for [product] in the past year?",
    },
    {
      heading: "Pending referrals - territory",
      description:
        "How many pending referrals are there currently in my territory?",
    },
    {
      heading: "Congresses or Conferences",
      description:
        "Has Dr [insert HCP] attended any congresses or conferences in the past year?",
    },
    {
      heading: "Speaker role",
      description:
        "Has Dr [insert HCP] been in a speaker role for any conferences or congresses during the last 2 years?",
    },
    {
      heading: "Tracking goals",
      description: "How am I tracking against my goals for this quarter?",
    },
    {
      heading: "High growth potential",
      description: "Suggest some high growth potential HCPs to engage with",
    },
    {
      heading: "Call prep",
      description: "Help me prep for my call with Dr [insert HCP]",
    },
    {
      heading: "Significant trends",
      description:
        "Are there any significant trends to be aware of in my territory?",
    },
    {
      heading: "Starts - increase",
      description:
        "Which HCPs are driving the increase in starts for the  [Product] over the last 3 months?",
    },
    {
      heading: "Starts - decrease",
      description:
        "Which HCPs are driving the decrease in starts for the  [Product] over the last 3 months?",
    },
    {
      heading: "Referrals - increase",
      description:
        "Which HCPs are driving the increase in referrals for the  [Product] over the last 3 months?",
    },
    {
      heading: "Referrals - decrease",
      description:
        "Which HCPs are driving the decrease in referrals for the  [Product] over the last 3 months?",
    },
    {
      heading: "Research articles",
      description:
        "Has Dr. [insert HCP] published any research articles during the last 2 years?",
    },
    {
      heading: "Published journals",
      description:
        "Which journals has Dr. [insert HCP] been published in during the last year?",
    },
    {
      heading: "Key messages - last 5 interactions",
      description:
        "What are the key messages from last 5 interactions with Dr. [insert HCP]",
    },
    {
      heading: "Last Meet",
      description: "When was the last time I met with Dr. [insert HCP]?",
    },
    {
      heading: "Key messages - last meet",
      description:
        "What key messages did I discuss with Dr. [insert HCP] last time we met?",
    },
    {
      heading: "Clinical trials",
      description:
        "Has Dr. [insert HCP] been involved in any clinical trials during the last 2 years?",
    },
    {
      heading: "Lead sponsors",
      description:
        "Which organizations are the lead sponsors for the clinical trials that Dr. X is a part of?",
    },
    {
      heading: "Clinical trial - participation",
      description:
        "Which target HCPs have participated in a clinical trial in the past two years?",
    },
    {
      heading: "Visit to facility",
      description: "Help me prep for a visit to [insert facility]",
    },
    // {
    //   heading: "Discontinuations",
    //   description:
    //     "How many discontinuations do I have this quarter for tyvaso?",
    // },
    // {
    //   heading: "Trends",
    //   description:
    //     "What HCPs are driving the [increase or decrease] in starts?",
    // },
    // {
    //   heading: "Sales and Marketing strategy",
    //   description:
    //     "Help me with key components of a Sales and Marketing strategy?",
    // },
    {
      heading: "Most Starts",
      description: "What facilities have the most Starts in my territory.",
    },
    {
      heading: "Most Referrals",
      description: "What facilities have the most Referrals in my territory.",
    },
    {
      heading: "Most Pending referrals",
      description:
        "What facilities have the most Pending Referrals in my territory.",
    },
    {
      heading: "Competitor performance",
      description:
        "Summarize performance of competitor [Winrevair/Uptravi/Ofev/Esbriet] in my territory.",
    },
  ],
  //   rbd: [
  //     {
  //       heading: "Region Performance",
  //       description:
  //         "How is my region performing this quarter?",
  //     },
  //     {
  //       heading: "Growth potential",
  //       description:
  //         "What target HCPs have a high growth potential?",
  //     },
  //     {
  //       heading: "Starts - sales rep",
  //       description:
  //         "How many starts does [sales rep name] have this quarter?",
  //     },
  //     {
  //       heading: "Referral for product",
  //       description:
  //         "Who has not written a referral for [product] in the past year",
  //     },
  //     {
  //       heading: "Key trends",
  //       description:
  //         "What are key trends in my [NAME] territory?",
  //     },
  //     {
  //       heading: "Performance review prep",
  //       description: "Help me prep for a performance review call with [insert sales rep]"
  //     },
  //     {
  //       heading: "Significant trends ",
  //       description: "What are the significant trends in my region?"
  //     },
  //     {
  //       heading: "Non-target HCPs",
  //       description: "What non-target HCPs have a high growth potential?"
  //     },
  //     { heading: "Starts - quarter",
  //       description: "How many starts does [territory] have this quarter?"
  //     },
  //     { heading: "Call prep",
  //       description: "Help me prep for a call with Dr [insert HCP]"
  //     },
  //     { heading: "Pending referrals",
  //       description: "How many pending referrals are there in [insert territory] currently?"
  //     },
  //     { heading: "Starts - increase",
  //       description: "Which HCPs are driving the increase in starts for the  [Product] over the last 3 months?"
  //     },
  //     { heading: "Starts - decrease",
  //       description: "Which HCPs are driving the decrease in starts for the  [Product] over the last 3 months?"
  //     },
  //     { heading: "Referrals - increase",
  //       description: "Which HCPs are driving the increase in referrals for the  [Product] over the last 3 months?"
  //     },
  //     { heading: "Referrals - decrease",
  //       description: "Which HCPs are driving the decrease in referrals for the  [Product] over the last 3 months?"
  //     },
  //     { heading: "Reach and frequency",
  //       description: "Summarize the reach and frequency for the region"
  //     },
  //     { heading: "Territories trend",
  //       description: "Which territories are driving the increase/decrease in starts/referrals for the [Product] over the last 3/6 months"
  //     },
  //     { heading: "Pending referrals > 10 days",
  //       description: "Which HCPs have pending referrals for longer than 10 days in [Territory Name] territory ? "
  //     },
  //     { heading: "Starts - quarter",
  //       description: "How many starts do I have for this quarter?"
  //     },
  //     { heading: "Starts - sales rep",
  //       description: "How many starts does [sales rep name] have for this quarter?"
  //     },
  //     { heading: "Starts - territory",
  //       description: "How many starts does [territory name] territory have for this quarter?"
  //     },
  //     { heading: "Discontinuations - last month",
  //       description: "How many discontinuations did I have last month?"
  //     },
  //     // { heading: "Active patients",
  //     //   description: "How many active patients are there for [Product] in the nation?"
  //     // },
  //      { heading: "Discontinuations - sales rep",
  //       description: "How many discontinuations did [sales rep name] have last month?"
  //     },
  //      { heading: "Discontinuations - territory",
  //       description: "How many discontinuations did [territory name] territory have last month?"
  //     },
  //     { heading: "Discontinuation - reason",
  //       description: "What is the most common reason for discontinuation in [territory name] territory this quarter?"
  //     },
  //     { heading: "Total starts",
  //       description: "What are the total starts for [Product] in [territory name] territory in the last 12 months?"
  //     },
  //     { heading: "Referrals - territory",
  //       description: "How many referrals of [Product] have there been in the [territory name] territory?"
  //     },
  //     // { heading: "Starts - last month",
  //     //   description: "How many no starts did I have last month?"
  //     // },
  //     // {
  //     //   heading: "Visit to HCO",
  //     //   description: "Help me prepare for a visit to the [HCO Name]"
  //     // },
  //     {
  //       heading: "Visit to institute",
  //       description: "Help me prepare for a visit to the [InstituteName]"
  //     },
  // {
  //       heading: "Most Starts - region",
  //       description: "What facilities have the most starts in my region?"
  //     },
  //     {
  //       heading: "Most Referrals - region",
  //       description: "What facilities have the most referrals in my region?"
  //     },
  //     {
  //       heading: "Most Pending referrals - region",
  //       description: "What facilities have the most pending referrals in my region?"
  //     },
  //     {
  //       heading: "Most Starts - territory",
  //       description: "What facilities have the most starts in [TerritoryName]?"
  //     },
  //     {
  //       heading: "Most Referrals - territory",
  //       description: "What facilities have the most referrals in [TerritoryName]?"
  //     },
  //     {
  //       heading: "Most Pending referrals - territory",
  //       description: "What facilities have the most pending referrals in [TerritoryName]?"
  //     },
  //     {
  //       heading: "Competitor performance - region",
  //       description: "Summarize performance of competitor [Winrevair/Uptravi/Ofev/Esbriet] in my region."
  //     },
  //     {
  //       heading: "Competitor performance - territory",
  //       description: "Summarize performance of competitor [Winrevair/Uptravi/Ofev/Esbriet] in [TerritoryName]."
  //     },
  //   ],
  others: [
    {
      heading: "Research Summary",
      description: "Give me summary of journal Immunotherapy for Lung Cancer",
    },
    {
      heading: "Source Information",
      description: "What is the source for LDL-C?",
    },
    {
      heading: "Call Coverage",
      description: "What is my current call coverage?",
    },
  ],

  SALESREP: {
    "Territory Performance": [
      "How am I tracking against my goals for this quarter?",
      "I'm trending [X] starts from goal — which HCP or account is my biggest opportunity to close the gap?",
      "What are the key trends in my territory?",
      "Give me a breakdown of my referrals this quarter by latest status and top discontinuation reason",
      "What is the trend for treatment rate and median time to therapy over the last 6 months?",
      // "How many starts / discontinuations / no starts / pending referrals do I have this quarter?",
      // "Have my no starts been increasing month over month?",
      // "What is the most common reason for discontinuation in my territory this quarter?",
      // "Summarize the performance of [insert competitor] for [time period]",
      // "Give me a breakdown of DCs in the last 6 months by product",
      // "Show me referrals for [insert product] that ended in a no start",
      // "What is the [reach/frequency] goal status in my Territory at the [decile/tier] level?",
    ],

    "Mobile Locker": [
      "What materials related to [insert product] can I share with an HCP?",
      // "What are the latest resources for [insert product]?",
    ],

    "HCP/HCO Targeting & Identification": [
      "Suggest some high growth potential HCPs to engage with",
      "Which Decile 10 HCPs have I not met with in the last 3 months?",
      "Which HCPs have no patients on 80mcg? Rank them by active patient count",
      "Which HCPs have increasing PAH signaling therapy claims in the last 3 months but no starts for [insert product]?",
      "Which new HCPs were added to my territory in the last 2 months that I haven't contacted?",
      "Which HCPs have pending referrals for longer than 10 days?",
      // "Which targets have not been contacted in the past 60 days?",
      // "Which HCP has the most starts this quarter?",
      // "Who has not written a referral for [insert product] in the past year?",
      // "Which HCPs are driving the increase/decrease in starts / referrals / no starts / discontinuations for [insert product] in the last 3/6 months?",
      // "Which HCPs have attended a medical congress related to [insert topic]?",
      // "What facilities have the most starts/referrals/pending referrals in my territory?",
      // "Which target HCPs have participated in a clinical trial in the past two years?",
      // "Which HCPs have had a publication in the PAH / PH-ILD space in the past year?",
    ],

    "Call Preparation": [
      "Help me prep for a call with Dr [insert HCP name]",
      "Help me prep for a visit to [insert HCO name]",
      "What are the key messages from my last 5 interactions with Dr [insert HCP name]?",
      "Has Dr [insert HCP name] been involved in any clinical trials, congresses, or publications in the past 2 years?",
      // "How many starts did Dr [insert HCP name] have for [insert product] in the last quarter?",
      // "Has Dr [insert HCP name] attended any congresses or conferences in the past year?",
      // "Has Dr [insert HCP name] been in a speaker role for any conferences or congresses in the past 2 years?",
      // "When was the last time I met with Dr [insert HCP name]?",
      // "What key messages did I discuss with Dr [insert HCP name] last time we met?",
      // "In which journals has Dr [insert HCP name] been published in the last year?",
      // "Has Dr [insert HCP name] been involved in any clinical trials during the last 2 years?",
      // "Which organizations are the lead sponsors for the clinical trials that Dr [insert HCP name] is involved in?",
      // "Has Dr [insert HCP name] published any research articles during the last two years?",
      // "Which focus area is being targeted for the most recent clinical trial Dr [insert HCP name] is involved in?",
    ],

    "QBR Prep Support": [
      "Which HCPs have increasing referrals over 6 months but decreasing over the last 3?",
      "Which HCPs are driving the change in starts / referrals / no starts / DCs for [insert product]?",
      "Build me a bar chart of my top 10 HCPs by [insert product] starts this quarter",
      // "Summarize key trends in my territory",
      // "What are some high growth potential HCPs?",
      // "Which HCPs are driving the increase/decrease in starts / referrals / no starts / discontinuations for [insert product] in the last 3/6 months?",
      // "Give me a summary of Dr [insert HCP name]",
    ],

    "ct.gov": EXTERNAL_SOURCES_CT_GOV_PROMPTS,
    pubmed: EXTERNAL_SOURCES_PUBMED_PROMPTS,

    "Training Compass": [
      "How do I log a call, and how long until it appears in Veeva CRM?",
      // "Can I use voice to text when logging a call?",
      // "How do I prepare for an HCP call using RepAssist?",
      // "Where can I find prebuilt prompts for call preparation?",
      // "Can I review my previous call preparation notes before a meeting?",
      // "How can RepAssist help me prepare for a QBR?",
      // "Can RepAssist generate engagement strategies for my QBR?",
      // "How do I identify high growth HCPs in my territory?",
      // "What is RepAssist and what does it do?",
      // "What is Synapse360?",
      // "What kind of data does RepAssist bring together?",
      // "I have a last-minute appointment with a KOL tomorrow. How can RepAssist help?",
      // "My RBD is doing a ride along tomorrow and I need to prepare quickly. What should I do?",
      // "It's Monday morning and I need to plan my week. How can RepAssist help an RBD?",
    ],
  },
  RBD: {
    "Territory Performance": [
      "How is [insert territory] tracking against their goals for this quarter?",
      "What are key trends in [insert territory]?",
      "Give me a breakdown of the referrals this quarter by latest status and top discontinuation reason for [insert territory]",
      "What is the trend for treatment rate and median time to therapy over the last 6 months for [insert territory]?",
      // "How many pending referrals are there in [insert territory] currently?",
      // "How many starts/referrals/no starts/discontinuations did [insert sales rep / territory] have this quarter?",
      // "What is the most common reason for discontinuation in [insert territory] this quarter?",
      // "What are the total starts for [insert product] in [insert territory] in the last 12 months?",
      // "Which territories are driving the increase / decrease in starts/referrals/no starts/discontinuations for [insert product] over the last 3/6 months?",
      // "Give me a breakdown of discontinuations in the last 6 months by product",
      // "Give me a breakdown of discontinuations for [insert product] in the last 6 months",
      // "Show me [insert product] referrals that ended in a no start?",
      // "What is the [reach/frequency] goal status for [Territory/Rep] at the [decile/tier] level?",
    ],

    "Mobile Locker": [
      "What materials related to [insert product] can I share with an HCP?",
      // "What are the latest resources for [insert product]?",
    ],

    "HCP/HCO Targeting & Identification": [
      "Suggest some high growth potential HCPs to engage with",
      "Which Decile 10 HCPs have I not met with in the last 3 months?",
      "Which HCPs have no patients on 80mcg? Rank them by active patient count",
      "Which HCPs have increasing PAH signaling therapy claims in the last 3 months but no starts for [insert product]?",
      "Which new HCPs were added to my territory in the last 2 months that I haven't contacted?",
      "Which HCPs have pending referrals for longer than 10 days?",
      // "Which non-target/target HCPs are high growth potential?",
      // "Who has not written a referral for [insert product] in the past year?",
      // "Which HCPs are driving the increase/decrease in starts/referrals/no starts/discontinuations over the last 3/6 months?",
      // "Which HCPs have referrals pending for longer than 10 days in [insert territory name]?",
      // "Which targets have not been contacted in the past 60 days in [insert territory]?",
      // "Which HCP has the most starts this quarter?",
      // "Give me a summary of [insert HCP name]",
      // "What facilities have the most pending referrals in my region?",
      // "What facilities have the most starts in my region?",
      // "What facilities have the most pending referrals/referrals/starts in [insert territory]?",
    ],

    "Call Preparation": [
      "Help me prep for a call with Dr [insert HCP name]",
      "Help me prep for a visit to [insert HCO name]",
      "Has Dr [insert HCP name] been involved in any clinical trials, congresses, or publications in the past 2 years?",
      "Help me prep for a performance review call with [insert sales rep name]",
    ],

    "Region Performance": [
      "How is my region performing this quarter?",
      "Which territories are driving the increase in referrals over the last 3 months?",
      "Summarize the reach and frequency of my region",
      // "What are the significant trends in my region?",
      // "Which territories are driving the increase / decrease in starts/referrals/no starts/discontinuations for [insert product] over the last 3/6 months?",
      // "How many starts does my region have this quarter?",
      // "How many discontinuations did my region have last month?",
      // "Summarize the performance of [insert competitor]",
    ],

    // "Rep Coaching": [
    //   "How many starts does [insert sales rep name] have for this quarter?",
    // ],

    "ct.gov": EXTERNAL_SOURCES_CT_GOV_PROMPTS,
    pubmed: EXTERNAL_SOURCES_PUBMED_PROMPTS,

    "Training Compass": [
      "What data is currently available on RepAssist?",
      // "How do I log a call in RepAssist?",
      // "Can I use voice to text when logging a call?",
      // "How long does it take for a logged call to appear in Veeva CRM?",
      // "How do I prepare for an HCP call using RepAssist?",
      // "Where can I find prebuilt prompts for call preparation?",
      // "Can I review my previous call preparation notes before a meeting?",
      // "How can RepAssist help me prepare for a QBR?",
      // "Can RepAssist generate engagement strategies for my QBR?",
      // "How do I identify high growth HCPs in my territory?",
      // "What is RepAssist and what does it do?",
      // "What is Synapse360?",
      // "I have a last-minute appointment with a KOL tomorrow. How can RepAssist help?",
      // "My RBD is doing a ride along tomorrow and I need to prepare quickly. What should I do?",
      // "It's Monday morning and I need to plan my week. How can RepAssist help an RBD?",
    ],
  },
  LEADERSHIP: {
    "National Performance": [
      "Summarize the national performance of [ProductGroup]",
      "Summarize key trends in the nation for [ProductGroup]",
      "How is the [SalesGroup] group tracking towards the reach and frequency goals?",
    ],
    "Territory Performance": [
      // "What are key trends in [sales group] [territory name] territory?",
      // "How many pending referrals are there in [sales group][insert territory] currently?",
      // "How many discontinuations did [sales group][sales rep /territory] have this quarter?",
      // "What is the most common reason for discontinuation in [sales group][sales rep /territory] territory this quarter?",
      // "How many referrals of [Product] have there been in the [territory name] territory?",
      // "How many starts does [sales group][territory] have for this quarter?",
      // "What are the total starts for [Product] in [territory name] territory in the last 12 months?",
      // "How many referrals of [Product] have there been in the [territory name] territory?",
      // "Summarize performance of [competitorName] in [TerritoryName]",
      // "Which territories are driving the increase/decrease in no starts/discontinuations for the [Product] over the last 3/6 months",
      // "Which HCPs in [Territory Name] are driving the increase/decrease in starts/referrals for the  [Product] over the last 3/6 months?",
      // "How is [sales group][sales rep / territory] tracking against their goals this quarter?",
      // "What are the most common reasons for discontinuation for [sales group] [territory / sales rep]",
      // "How many no starts did [sales group][territory / sales rep] have last month?",
      // "How many pending referrals are there in [sales group][territory / sales rep]",
      "Which territories are driving the increase/decrease in [Metric] for [ProductGroup]",
      "What is the [reach/frequency] goal status for [Group] [Territory/Region/Rep] at the [decile/tier] level?"
    ],

    "Region Performance": [
      // "How is [region] performing this quarter?",
      // "What are the significant trends in [region]?",
      // "Which territories are driving the increase/decrease in starts/referrals for the [Product] over the last 3/6 months",
      // "Summarize the reach and frequency [region]",
      // "How many starts does [region] have for this quarter?",
      // "How many discontinuations did [region] have last month?",
      // "Summarize performance of competitor [Winrevair/Uptravi/Ofev/Esbriet] in [region].",
      // "What facilities have the most pending referrals in [region]?",
      // "What facilities have the most referrals in [region]?",
      // "What facilities have the most starts in [region]?",
      "Summarize the performance of [SalesGroup] [region] this quarter",
      "Summarize the reach and frequency for [SalesGroup] [region]",
    ],

    "HCP/HCO Targetting & Identification": [
      // "What (non-target/target /all) HCPs are high growth potential?",
      // "Who has not written a referral for [product] in the past year",
      // "Which HCPs are driving the increase/decrease in starts/referrals for the  [Product] over the last 3/6 months?",
      // "Which HCPs have pending referrals for longer than 10 days in [Territory Name] territory ?",
      // "Which targets have not been contacted in the past 60 days in [Territory Name] territory ?",
      // "What HCP has the most starts this quarter?",
      // "Help me prep for my call with Dr [HCP name]",
      // "Which HCPs are driving the increase/decrease in no starts/discontinuations for the  [Product] over the last 3/6 months?",
      // "Help me prepare for a visit to the [InstituteName]",
      // "What facilities have the most pending referrals in [sales group][TerritoryName]?",
      // "What facilities have the most referrals in  [sales group][TerritoryName]?",
      // "What facilities have the most starts in  [sales group][TerritoryName]?",
      // "What facilities have the most pending referrals for  [sales group][Sales Rep Name]?",
      // "What facilities have the most referrals for  [sales group][Sales Rep Name]?",
      // "What facilities have the most starts for  [sales group][Sales Rep Name]?",
      "Give me a summary of Dr [Insert HCP]​",
    ],

    "ct.gov": EXTERNAL_SOURCES_CT_GOV_PROMPTS,
    pubmed: EXTERNAL_SOURCES_PUBMED_PROMPTS,

    "Training Compass": [
      "How do I log a call in RepAssist?",
      "Can I use voice to text when logging a call?",
      "How long does it take for a logged call to appear in Veeva CRM?",
      "How do I prepare for an HCP call using RepAssist?",
      "Where can I find prebuilt prompts for call preparation?",
      "Can I review my previous call preparation notes before a meeting?",
      "How can RepAssist help me prepare for a QBR?",
      "Can RepAssist generate engagement strategies for my QBR?",
      "How do I identify high growth HCPs in my territory?",
      "What is RepAssist and what does it do?",
      "What is Synapse360?",
      "What kind of data does RepAssist bring together?",
      "I have a last-minute appointment with a KOL tomorrow. How can RepAssist help?",
      "My RBD is doing a ride along tomorrow and I need to prepare quickly. What should I do?",
      "It's Monday morning and I need to plan my week. How can RepAssist help an RBD?",
    ],

    // "Rep Coaching": [
    //   "How many starts does [sales rep] have for this quarter?",
    //   "Help me prep for a performance review call with [sales rep name]",
    // ],
  },
};

export const TRAINING_COMPASS_CATEGORY = "Training Compass";
export const TRAINING_COMPASS_TOOL_ID = "knowledge_bot";
export const EXTERNAL_SOURCES_TOOL_ID = "external_sources";

export const TOOL_PROMPT_CATEGORY_GROUPS = {
  [TRAINING_COMPASS_TOOL_ID]: [TRAINING_COMPASS_CATEGORY],
  [EXTERNAL_SOURCES_TOOL_ID]: EXTERNAL_SOURCES_CATEGORY_NAMES,
};

export const ALL_TOOL_PROMPT_CATEGORIES = Object.freeze([
  TRAINING_COMPASS_CATEGORY,
  ...EXTERNAL_SOURCES_CATEGORY_NAMES,
]);

const getPromptsForToolCategory = (role, category, limit) => {
  const normalizedRole = (role || "SALESREP").trim().toUpperCase();
  const prompts = PromptDialogData[normalizedRole]?.[category] || [];
  return limit != null ? prompts.slice(0, limit) : prompts;
};

export const getTrainingCompassPromptsForRole = (role, limit) =>
  getPromptsForToolCategory(role, TRAINING_COMPASS_CATEGORY, limit);

export const getExternalSourcesPromptsForRole = (role, limit) => {
  const normalizedRole = (role || "SALESREP").trim().toUpperCase();
  const prompts = EXTERNAL_SOURCES_CATEGORY_NAMES.flatMap(
    (category) => PromptDialogData[normalizedRole]?.[category] || []
  );
  return limit != null ? prompts.slice(0, limit) : prompts;
};
